import {View} from "./view.mjs";
import plannerTemplate from "../templates/planner.njk";
//import {SelectorView} from "./selector.view.mjs";
import {Dropdown, Dataset} from "@mecatran/dropdown-selector-component";
import { DateTime } from "../../../../@mecatran/components4/datetime-component/src/index.mjs";
import { Button } from "../../../../@mecatran/components4/button-component/src/index.mjs";
//var DropDownSelectorComponent = require('dropdown-selector-component-2');
import selectorTemplate from "../templates/selector.njk";
import {suggestionEngine} from "../services/suggestionengine/suggestionengine.mjs";
// import {banSuggestionEngine} from "../services/suggestionengine/bansuggestionengine.mjs"; // TODELETE
import {banSearchSuggestionEngineProvider} from "../services/suggestionengine/bansuggestionengine.provider.mjs"; // TMP
import stopSuggestionTemplate from "../templates/stop-suggestion.njk";
import poiSuggestionTemplate from "../templates/poi-suggestion.njk";
import addressSuggestionTemplate from "../templates/address-suggestion.njk";

//console.log('dropdownselectorcomponent',DropDownSelectorComponent)

export function plannerViewProvider(){

    var banSearchSuggestionEngine = banSearchSuggestionEngineProvider.get();

    class PlannerView extends View{
        constructor(){
            super();
            // var _selectorView = new SelectorView();
            var _deparrDropdown = PlannerView.createDeparrDropdown('deparr');
            var _date = PlannerView.createDatetimeSelector('date');
            var _time = PlannerView.createDatetimeSelector('time');
            var _plannerButton1 = PlannerView.createPlannerButton('google','');
            var _plannerButton3 = PlannerView.createPlannerButton('moovit','');
            var _plannerButton2 = PlannerView.createPlannerButton('mobigo','');
            var _originDropdown = PlannerView.createDropdownComponent('origin', this.getTrOriginPlaceholder());
            var _destinationDropdown = PlannerView.createDropdownComponent('destination', this.getTrDestinationPlaceholder());
        
        
            var _selectEventHandlers = []; // IMPROVE. This should be in View
            var _DOMNode = [];

            Object.defineProperty(this,'originDropdown',{
                get : function(){ return _originDropdown }
            });

            Object.defineProperty(this,'destinationDropdown',{
                get : function(){ return _destinationDropdown }
            });

/*
            Object.defineProperty(this,'selectorView',{
                get : function(){ return _selectorView }
            });
*/

            Object.defineProperty(this,'deparrDropdown',{
                get : function(){ return _deparrDropdown }
            });

            Object.defineProperty(this,'date',{
                get : function(){ return _date }
            });

            Object.defineProperty(this,'time',{
                get : function(){ return _time }
            });


            Object.defineProperty(this,'plannerButton1',{
                get : function(){ return _plannerButton1 }
            });
            Object.defineProperty(this,'plannerButton2',{
                get : function(){ return _plannerButton2 }
            });
            Object.defineProperty(this,'plannerButton3',{
                get : function(){ return _plannerButton3 }
            });

            Object.defineProperty(this,'selectEventHandlers',{
                get : function(){ return _selectEventHandlers }
            })

            Object.defineProperty(this,'DOMNode',{  
                set : function(d){ _DOMNode = d },
                get : function(){ return _DOMNode }
            })
    

        }

        initView(){

            var doc1 = this.getDocument();

            /* display origin-selector */ 
            var originDropdownDOMNode = this.getOriginSelectorDropdown().getDOMNode();
            var originDropdownDOMDoc = View.createDocumentFromNode(originDropdownDOMNode); // TMP
            //var doc1 = this.getDocument();
            var doc2 = originDropdownDOMDoc;
            var selector = '.planner .direction-origin .selector';
            View.copyDocument(doc1, doc2, selector);
            this.getOriginSelectorDropdown().setDocumentListener();
                     

            /* display destination-selector */
            var destinationDropdownDOMNode = this.getDestinationSelectorDropdown().getDOMNode();
            var destinationDropdownDOMDoc = View.createDocumentFromNode(destinationDropdownDOMNode); // TMP
            //var doc1 = this.getDocument();
            var doc2 = destinationDropdownDOMDoc;
            var selector = '.planner .direction-destination .selector';
            View.copyDocument(doc1, doc2, selector);
            this.getDestinationSelectorDropdown().setDocumentListener();           


            /* display deparr-selector */
            var selector = '.planner .deparr-selector'
            var deparrDropdownDOMNode = this.getDeparrDropdown().getDOMNode();
            var deparrDropdownDOMDoc = View.createDocumentFromNode(deparrDropdownDOMNode); // TMP 
            //var doc1 = this.getDocument();
            var doc2 = deparrDropdownDOMDoc;
            View.copyDocument(doc1, doc2, selector);

            this.onDeparrDropdownSelectEvent().addHandler((s)=>{ 
                console.log('selection',s);
                var value = s.value;
                switch(value){
                    case 'dep':
                    case 'arr':
                        /* display date-selector */
                        var selector = '.planner .datetime-selectors';
                        var dateSelectorDOMNode = this.getDateSelector().getDOMNode();
                        var dateSelectorDOMDoc = View.createDocumentFromNode(dateSelectorDOMNode); // TMP 
                        //var doc1 = this.getDocument();
                        var doc1 = document;
                        var doc2 = dateSelectorDOMDoc;
                        View.copyDocument(doc1, doc2, selector);

                        /* display date-selector */
                        var selector = '.planner .datetime-selectors';
                        var timeSelectorDOMNode = this.getTimeSelector().getDOMNode();
                        var timeSelectorDOMDoc = View.createDocumentFromNode(timeSelectorDOMNode); // TMP 
                        //var doc1 = this.getDocument();
                        var doc1 = document;
                        var doc2 = timeSelectorDOMDoc;
                        View.copyDocument(doc1, doc2, selector);
                        break;
                    case 'leaveNow':
                        var date = this.getDateSelector();
                        date.setDefaultValue();
                        var time = this.getTimeSelector();
                        time.setDefaultValue();
                        this.closeDateTime();
                        break;
                }
            });




            /* display planner buttons */
            /* Google */
            
            var selector = '.planner .search-buttons';
            var plannerButtonDOMNode = this.getPlannerButton1().getDOMNode();
            var plannerButtonDOMDoc = View.createDocumentFromNode(plannerButtonDOMNode); // TMP 
            //var doc1 = this.getDocument();
            var doc2 = plannerButtonDOMDoc;
            View.copyDocument(doc1, doc2, selector); 
            

            /* Moovit */ 
            
            var plannerButtonDOMNode = this.getPlannerButton2().getDOMNode();
            var plannerButtonDOMDoc = View.createDocumentFromNode(plannerButtonDOMNode); // TMP 
            //var doc1 = this.getDocument();
            var doc2 = plannerButtonDOMDoc;
            View.copyDocument(doc1, doc2, selector);
            
            
            /* Mobigo */
            var plannerButtonDOMNode = this.getPlannerButton3().getDOMNode();
            var plannerButtonDOMDoc = View.createDocumentFromNode(plannerButtonDOMNode); // TMP 
            //var doc1 = this.getDocument();
            var doc2 = plannerButtonDOMDoc;
            View.copyDocument(doc1, doc2, selector);           
            
            this.getPlannerButton1().addClickEventHandler(this.collectAllValues.bind(this));
            this.getPlannerButton2().addClickEventHandler(this.collectAllValues.bind(this));
            this.getPlannerButton3().addClickEventHandler(this.collectAllValues.bind(this));


            this.setDOMNode(); // TMP 
            this.setPlannerListeners();  // TMP. Improve should be automatic (inherited)
        }

        setDOMNode(){
            var document = this.getDocument();
            this.DOMNode =  document.querySelector('.planner')
        }

        getDOMNode(){
            return this.DOMNode;
        }

        getContext(){
            var context = {};
            context.getTrOriginSelectorLabel = this.getTrOriginSelectorLabel;
            context.getTrDestinationSelectorLabel = this.getTrDestinationSelectorLabel;
            context.getTrSearchButtonsLabel = this.getTrSearchButtonsLabel;
        
            return context; 
        }

        getTemplate(){ return plannerTemplate; }

        // getSelectorView(){ return this.selectorView }
        getSelectEventHandlers(){
            return this.selectEventHandlers;
        }

        getOriginSelectorDropdown(){ return this.originDropdown }

        getDestinationSelectorDropdown(){ return this.destinationDropdown }
    
        getTrOriginPlaceholder(){ return "Tapez une adresse ou le nom d'un arrêt"} // TMP Translations

        getTrOriginSelectorLabel(){ return "Départ" }  // TMP use translations 
    
        getTrDestinationPlaceholder(){ return "Tapez une adresse ou le nom d'un arrêt" }
    
        getTrDestinationSelectorLabel(){ return "Arrivée" }

        getTrSearchButtonsLabel(){ return "Recherchez votre itinéraire avec" }
    
    
        getPoiDatasetName(){ return PlannerView.datasetName.poi  }

        getStopDatasetName(){ return PlannerView.datasetName.stop }

        getBanDatasetName(){ return PlannerView.datasetName.ban }
    

        getDeparrDropdown(){ return this.deparrDropdown }

        getDateSelector(){ return this.date }

        getTimeSelector(){ return this.time }

        getPlannerButton1(){ return this.plannerButton1 }
        getPlannerButton2(){ return this.plannerButton2 }
        getPlannerButton3(){ return this.plannerButton3 }

        static createDropdownComponent(id, placeholder){
            return new Dropdown(id, null, placeholder, 'autocomplete')
        }

        static createStopDataset(stops, datasetName){
            var dataset = new Dataset(datasetName,20);
            dataset.setSyncDataSource(stops, ['name','cityName'], suggestionEngine);
            // dataset.templates.header = `<h2 class="${dataset.name}">Arrêts</h2>`; //TMP use translations 
            dataset.templates.suggestion = stopSuggestionTemplate;
            dataset.display = (suggestion)=>{
                 return `${suggestion.name} - ${ suggestion.cityName}`
                //return suggestion.name;
            };
            return dataset;
        }  
        
        static createPoiDataset(pois, datasetName){
            var dataset = new Dataset(datasetName, 6);
            var getQueriableFields = (feature) => {    
                return [feature.getProperties().getName(), feature.getProperties().getCity()]
            }
            dataset.setSyncDataSource(pois,getQueriableFields, suggestionEngine);  // Pois array of Feature
            // dataset.templates.header = `<h2 class="${dataset.name}">Lieux</h2>`; //TMP use translations 
            dataset.templates.suggestion = poiSuggestionTemplate;
            dataset.display = (feature)=>{
                 return `${feature.getProperties().getName()} - ${ feature.getProperties().getCity()}`
            };
            return dataset;
        }

        static createBanDataset(datasetName){
            var dataset = new Dataset(datasetName,3);
            dataset.setAsyncDataSource(banSearchSuggestionEngine);
            // dataset.templates.header =  `<h2 class="${dataset.name}">Adresses</h2>`; 
            dataset.templates.suggestion = addressSuggestionTemplate;
            // dataset.display = 'label';
            dataset.display = (feature) =>{
                return feature.getProperties().getLabel();
            }
            return dataset;
        }

        static createDeparrDropdown(){
            var objects = [
                {text:'Partir maintenant',value:'leaveNow'},   // TMP Translation 
                {text:'Partir à', value:'dep'},
                {text:'Arriver à', value:'arr'}
            ];

            var dataset = new Dataset('options');
            dataset.setSyncDataSource(objects,['text']);
            dataset.display = 'text';         

            var dropdown = new Dropdown('deparr',[dataset],null, 'dropdown');
            dropdown.setDefaultValue();
            return dropdown;
        }

        static createDatetimeSelector(type){
            var datetime = new DateTime(type);
            datetime.setDefaultValue();
            return datetime; 
        }

        static createPlannerButton(id, placeholder){
            var button = new Button(id, placeholder);
            button.setDefaultValue(id);
            return button;
        }

        // events listeners
        // ----------------
        setPlannerListeners(){ 
            var plannerDOMNode = this.getDOMNode();
           plannerDOMNode.addEventListener('selectEvent',this.eventRouter.bind(this));
       }

        // events emitters 
        // ---------------
        emitSelectEvent(selection){
            var event = new CustomEvent('selectEvent', { 'detail': selection, bubbles: true });  // https://developer.mozilla.org/fr/docs/Web/API/Event/Event
            this.getDOMNode().dispatchEvent(event);
        } 

        // event router
        // ------------
        eventRouter(e){
            switch(e.type){
                case 'selectEvent':
                    this.onSelectEvent(e);
                    break;
            }
        }

        // event handler
        // -------------
        onSelectEvent(e){
            var selection = e.detail; 
            var array = this.getSelectEventHandlers();
            if (array.length)  array.forEach(handler => handler(selection));     
        }


        // public 
        // ------

        addOriginBan(){
            var banDataset = PlannerView.createBanDataset(this.getBanDatasetName())
            this.getOriginSelectorDropdown().addDataset(banDataset);
        }

        addDestinationBan(){
            var banDataset = PlannerView.createBanDataset(this.getBanDatasetName())
            this.getDestinationSelectorDropdown().addDataset(banDataset);            
        }

        addOriginPois(pois){
            var poiDataset = PlannerView.createPoiDataset(pois, this.getPoiDatasetName() );
            this.getOriginSelectorDropdown().addDataset(poiDataset);
        }

        addDestinationPois(pois){
            var poiDataset = PlannerView.createPoiDataset(pois, this.getPoiDatasetName() );
            this.getDestinationSelectorDropdown().addDataset(poiDataset);
        }

        addOriginStops(stops){
            var stopDataset = PlannerView.createStopDataset(stops, this.getStopDatasetName() );
            this.getOriginSelectorDropdown().addDataset(stopDataset);
        }
    
        addDestinationStops(stops){
            var stopDataset = PlannerView.createStopDataset(stops, this.getStopDatasetName());
            this.getDestinationSelectorDropdown().addDataset(stopDataset);
        }

        onDeparrDropdownSelectEvent(){  // rename AddDeparrDropdown
            var deparrDropdown = this.getDeparrDropdown();
            return {
                addHandler : (handler ) => {
                    deparrDropdown.addSelectEventHandler('options', handler);
                }
            }    
        }

        addSelectEventHandler(handler){
            var array = this.getSelectEventHandlers();
            array.push(handler)
        }

        // utils 
        // -----

        closeDateTime(){
            var selector = '.planner .datetime-selectors';
            var dateTimeSelector = document.querySelector(selector);
            while (dateTimeSelector.childElementCount){
                dateTimeSelector.removeChild(dateTimeSelector.children[0]);
            }          
        }

        collectAllValues(planner){
            var plannerParams = new PlannerParams();

            var originDropdown = this.getOriginSelectorDropdown();
            plannerParams.origin = originDropdown.getCurrentSelection();
            plannerParams.originDatasetName = originDropdown.getCurrentDatasetName();

            var destinationDropdown = this.getDestinationSelectorDropdown();
            plannerParams.destination = destinationDropdown.getCurrentSelection();
            plannerParams.destinationDatasetName = destinationDropdown.getCurrentDatasetName();

            plannerParams.date = this.getDateSelector().getCurrentSelection();
            plannerParams.time = this.getTimeSelector().getCurrentSelection();
            plannerParams.deparr = this.getDeparrDropdown().getCurrentSelection().value;
            plannerParams.planner = planner;

            this.emitSelectEvent(plannerParams);
        }


    }
    PlannerView.datasetName = { stop : 'stop', poi : 'poi', ban: 'ban' }

    return new PlannerView();
}





export class PlannerParams{
	constructor(){
		var  _origin, _originDatasetName, _destination, _destinationDatasetName, _date, _time, _deparr, _planner;
		
		
		Object.defineProperty(this,'origin',{
			set : function(v){
				_origin = v;
			},
			get : function(){
				return _origin;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'originDatasetName',{
			set : function(v){
				_originDatasetName = v;
			},
			get : function(){
				return _originDatasetName;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'destination',{
			set : function(v){
				_destination = v;
			},
			get : function(){
				return _destination;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'destinationDatasetName',{
			set : function(v){
				_destinationDatasetName = v;
			},
			get : function(){
				return _destinationDatasetName;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'date',{
			set : function(v){
				_date = v;
			},
			get : function(){
				return _date;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'time',{
			set : function(v){
				_time = v;
			},
			get : function(){
				return _time;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'deparr',{
			set : function(v){
				_deparr = v;
			},
			get : function(){
				return _deparr;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'planner',{
			set : function(v){
				_planner = v;
			},
			get : function(){
				return _planner;
			},
			enumerable : true
		});
		
    }
    
    getOrigin(){ return this.origin }
    getOriginDatasetName(){ return this.originDatasetName }
    getDestination(){ return this.destination }
    getDestinationDatasetName(){ return this.destinationDatasetName }
    getDeparr(){ return this.deparr }
    getDate(){ return this.date }
    getTime(){ return this.time }
    getPlanner(){ return this.planner }

    
}






